// Erzeugt eine schlichte, selbsterklärende HTML-Datei mit dem persönlichen
// Edit-Link einer Stimmabgabe. Doppelklick öffnet sie im Browser, der dicke
// Knopf führt direkt zu Slot — der Edit-Token sitzt als ?me=… im URL.
//
// Privacy: keine externen Ressourcen. Inhalt steht offline zur Verfügung.

export type EditFileInput = {
  title: string | null;
  origin: string;
  voterToken: string;
  editToken: string;
};

export function buildEditFile(input: EditFileInput): string {
  const titleText = input.title?.trim() || 'Slot Umfrage';
  const url = `${input.origin}/vote/${input.voterToken}?me=${input.editToken}`;
  const safeTitle = escapeHtml(titleText);
  const safeUrl = escapeHtml(url);

  return `<!doctype html>
<html lang="de">
<head>
<meta charset="utf-8">
<title>Slot — Stimme bearbeiten: ${safeTitle}</title>
<meta name="viewport" content="width=device-width, initial-scale=1">
<style>
  body { font: 16px/1.55 -apple-system, system-ui, sans-serif; color: #1a2233;
         background: #faf6ed; margin: 0; padding: 3rem 1.2rem; }
  .wrap { max-width: 36rem; margin: 0 auto; text-align: center; }
  h1 { font: 400 1.6rem/1.2 Georgia, serif; margin: 0 0 0.5rem; }
  h1 em { color: #c4574a; font-style: italic; }
  p { color: #4a566f; margin: 0.7rem 0; }
  a.btn { display: inline-block; margin: 1.6rem 0 0.6rem; padding: 1rem 1.6rem;
          background: #1a2233; color: #faf6ed; text-decoration: none;
          border-radius: 999px; font-weight: 600; }
  a.btn:hover { background: #c4574a; }
  .small { font-size: 0.85rem; color: #6b7180; word-break: break-all;
           background: rgba(26,34,51,0.06); padding: 0.5rem 0.75rem;
           border-radius: 6px; margin-top: 1.2rem; }
  .privacy { font-size: 0.78rem; color: #4a566f; margin-top: 2rem;
             padding: 0.7rem 1rem; background: rgba(47,158,86,0.1);
             border-radius: 6px; }
</style>
</head>
<body>
  <div class="wrap">
    <h1>Slot — <em>Stimme bearbeiten</em></h1>
    <p><strong>${safeTitle}</strong></p>
    <p>Klick auf den Knopf, um zu deiner Umfrage zurückzukehren und deine Antworten zu ändern. Der Link erkennt dich auch von einem anderen Gerät.</p>
    <a class="btn" href="${safeUrl}">Meine Stimme bearbeiten</a>
    <div class="small">${safeUrl}</div>
    <div class="privacy">
      🔒 <strong>Halt diesen Link für dich.</strong> Wer ihn hat, kann deine
      Antworten ändern. In der Slot-Datenbank ist nur der Hash gespeichert —
      wir können den Link nicht selbst rekonstruieren.
    </div>
  </div>
</body>
</html>`;
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function downloadEditFile(input: EditFileInput): void {
  const html = buildEditFile(input);
  const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const safeName = (input.title?.trim() || 'slot')
    .replace(/[^A-Za-z0-9äöüÄÖÜß \-_]/g, '')
    .substring(0, 40)
    .trim() || 'slot';
  a.href = url;
  a.download = `slot-edit-${safeName}.html`;
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
